<template>
    <div name="closeButton" class="button-row">
        <img src="../../assets/close.png" class="button" @click="close" />
    </div>
</template>

<script>
export default {
    name: 'closeButton',
    methods: {
        close: function()
        {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
    .button-row {
        width: 100%;    
        max-width: 600px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 49px;
        padding: 14px 6px 13px 21px;
        box-sizing: border-box;
    }
    .button {
        width: 22px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/CloseButton.vue